import React from 'react';
import { HOME_SEO } from '../data/dgpt';
import { usePageMeta, canonicalUrl } from '../hooks/usePageMeta';
import { HomeHero } from '../components/home/HomeHero';
import { ExploreSolutions } from '../components/home/ExploreSolutions';
import { MeetAgentsSection } from '../components/home/MeetAgentsSection';
import { VcProofSection } from '../components/home/VcProofSection';
import { BuilderFeature } from '../components/home/BuilderFeature';
import { WorkflowBuilderSection } from '../components/home/WorkflowBuilderSection';
import { PartnersCallout } from '../components/home/PartnersCallout';
import { HumanControl } from '../components/platform/HumanControl';
import { SecuritySection } from '../components/home/SecuritySection';
import { ProcessCta } from '../components/platform/ProcessCta';
import { MobileStickyCta } from '../components/dgpt/MobileStickyCta';
export function Home() {
  usePageMeta({
    title: HOME_SEO.title,
    description: HOME_SEO.description,
    path: '/',
    keywords: [...HOME_SEO.keywords],
    jsonLd: [{
      '@type': 'SoftwareApplication',
      name: 'DiligenceGPT™',
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'Web',
      url: canonicalUrl('/'),
      description: HOME_SEO.description,
      publisher: {
        '@id': 'https://www.startupfuel.com/#organization'
      }
    }]
  });
  return <>
      <main id="main" data-id="element-1887" data-mp="2hxnlxobdaxvs">
        <HomeHero data-id="element-1888" data-mp="2hyyxiab219xg" />
        <ExploreSolutions data-id="element-1889" data-mp="2hzi3qtrce9vn" />
        <MeetAgentsSection data-id="element-1890" data-mp="2hzqk4vmobxbl" />
        <BuilderFeature data-id="element-1891" data-mp="2d6p1qdn9dfn9" />
        <VcProofSection data-id="element-1892" data-mp="2d6f90iatwudv" />
        <WorkflowBuilderSection data-id="element-1893" data-mp="2d5w2ryujjufo" />
        <PartnersCallout data-id="element-1894" data-mp="287ujbct7dt3o" />
        <HumanControl placement="home" data-id="element-1895" data-mp="2895nhdqk92vb" />
        <SecuritySection data-id="element-1896" data-mp="2861c9weoh6v5" />
        <ProcessCta placement="home" data-id="element-1897" data-mp="239awla6scda9" />
      </main>
      <MobileStickyCta data-id="element-1898" data-mp="23alz76ohvezs" />
    </>;
}